// declare namespace NodeJS {
//     export interface timeout {

//     }
// }

const transitionReset = (element1: string, element2: string = '') => {
    let resizeTimer: ReturnType<typeof setTimeout>
    const target1 = document.querySelector(`${element1}`) as HTMLElement
    const target2 = document.querySelector(`${element2}`) as HTMLElement

    window.addEventListener('resize', () => {
        // Remove all transitions
        target1.style.transition = 'none'
        target2.style.transition = 'none'

        // clear timeout throughout resize
        clearTimeout(resizeTimer)

        resizeTimer = setTimeout(() => {
            target1.style.transition = 'var(--transition-medium)'
            target2.style.transition = 'var(--transition-medium)'
        }, 250)
    })
}

export default transitionReset
